import React, {CSSProperties} from 'react'
import convertUnit from 'lib/unit'
import styled from 'styled-components'
import {Icon} from '../Icon'

interface Dimension {
  size?: number
}

const StyledPackage = styled.div<Dimension>`
  ${({size = 64}) => ({
    width: convertUnit(size),
    height: convertUnit(size),
  })};
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({theme}) => theme.info_1};
  border-radius: ${convertUnit(8)};
`

export default function PackageIcon({
  size,
  style,
}: {
  size?: number
  style?: CSSProperties
}) {
  return (
    <StyledPackage size={size} style={style}>
      <Icon type="collection" color="primary_5" />
    </StyledPackage>
  )
}
